import React, { useState, useEffect } from 'react';
import { baseURL } from '../apiConfig'; // <-- Apni nayi central file se baseURL import kiya

import axios from 'axios';
import './EnquiryDashboard.css';

const EnquiryDashboard = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('all');
  
  // 📝 Live remarks input track karne ke liye state
  const [liveRemarks, setLiveRemarks] = useState({});

  const fetchEnquiries = async () => {
    setLoading(true);
    try {
      // const baseURL = process.env.REACT_APP_API_URL || 'http://10.179.18.97:8000';
      const response = await axios.get(`${baseURL}/api/sales-order/list/`);
      
      if (response.data.success) {
        const data = response.data.data || response.data.enquiries;
        setEnquiries(data);
        
        // Initializing live remarks object with existing db remarks
        const initialRemarks = {};
        data.forEach(enq => {
          initialRemarks[enq.slno] = enq.seller_remarks || '';
        });
        setLiveRemarks(initialRemarks);
      }
    } catch (error) {
      console.error("Enquiries load karne me error:", error);
      alert("Bhai, enquiries fetch nahi ho payi!");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchEnquiries();
  }, []);

  // 🔄 Status aur Remarks ko Backend me save karne ka master function
  const handleUpdateEnquiry = async (slno, updatedStatus, updatedRemarks) => {
    try {
      // const baseURL = process.env.REACT_APP_API_URL || 'http://10.179.18.97:8000';
      const response = await axios.post(`${baseURL}/api/sales-order/update-status/`, {
        slno: slno,
        status: updatedStatus,
        seller_remarks: updatedRemarks
      });
      if (response.data.success) {
        alert("🎉 Changes successfully save ho gaye!");
        fetchEnquiries(); // Data refresh
      }
    } catch (error) {
      console.error("Update error:", error);
      alert("Bhai, update karne me koi dikkat aayi!");
    }
  };

  // Live input changes sync karne ke liye
  const handleRemarksInputChange = (slno, val) => {
    setLiveRemarks(prev => ({
      ...prev,
      [slno]: val
    }));
  };

  const filteredEnquiries = enquiries.filter(item => {
    if (statusFilter === 'all') return true;
    return item.status?.toLowerCase() === statusFilter.toLowerCase();
  });

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h2>📋 Customer Enquiries Dashboard (Admin/Manager)</h2>
        <button onClick={fetchEnquiries} className="refresh-btn">🔄 Refresh Data</button>
      </div>

      <div className="dashboard-filter">
        <label>Filter by Status: </label>
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="all">All Enquiries</option>
          <option value="pending">⏳ Pending</option>
          <option value="contacted">📞 Contacted</option>
          <option value="completed">✅ Completed</option>
        </select>
      </div>

      {loading ? (
        <div className="loading-text">Bhai, data load ho raha hai...</div>
      ) : (
        <div className="table-responsive">
          <table className="enquiry-table">
            <thead>
              <tr>
                <th>SlNo / ID</th>
                <th>Customer Name</th>
                <th>Mobile Number</th>
                <th>Tag ID / Item</th>
                <th>Customer Remarks</th>
                <th>📝 Seller Remarks (Staff/Admin)</th>
                <th>Action / Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredEnquiries.length === 0 ? (
                <tr>
                  <td colSpan="7" className="no-records">Koi enquiry nahi mili, bhai!</td>
                </tr>
              ) : (
                filteredEnquiries.map((enq) => (
                  <tr key={enq.slno}>
                    <td><b>#{enq.slno}</b></td>
                    <td>{enq.customer_name}</td>
                    <td>
                      <a href={`tel:${enq.customer_mobile}`} className="phone-link">
                        📞 {enq.customer_mobile}
                      </a>
                    </td>
                    <td>
                      <span className="tag-badge-dash">{enq.tag_id}</span>
                      {/* <div style={{ fontSize: '11px', color: '#666', marginTop: '3px' }}>{enq.item_name || 'N/A'}</div> */}
                      <div style={{ fontSize: '11px', marginTop: '3px' }}>{enq.item_name || 'N/A'}</div>
                    </td>
                    <td className="remarks-cell" title={enq.customer_remarks}>{enq.customer_remarks || '-'}</td>
                    
                    {/* 📝 NEW: Editable Seller Remarks Field */}
                    <td>
                      <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                        <input 
                          type="text"
                          className="seller-remarks-input"
                          placeholder="Add staff notes here..."
                          value={liveRemarks[enq.slno] || ''}
                          onChange={(e) => handleRemarksInputChange(enq.slno, e.target.value)}
                        />
                        <button 
                          title="Save Remark"
                          className="save-remark-btn"
                          onClick={() => handleUpdateEnquiry(enq.slno, enq.status, liveRemarks[enq.slno])}
                        >
                          💾
                        </button>
                      </div>
                    </td>

                    <td>
                      <select 
                        value={enq.status || 'Pending'} 
                        onChange={(e) => handleUpdateEnquiry(enq.slno, e.target.value, liveRemarks[enq.slno])}
                        className={`status-select ${enq.status?.toLowerCase()}`}
                      >
                        <option value="Pending">⏳ Pending</option>
                        <option value="Contacted">📞 Contacted</option>
                        <option value="Completed">✅ Completed</option>
                      </select>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EnquiryDashboard;